<template lang="pug">
    v-card
      v-card-title.dialog-card-title
        p Actualizar productos
        v-icon(color="white" aria-label="Close" @click="cancel") mdi-close
      v-card-text.text-center.px-3
        v-row
          v-col(cols="12" md="12")
            v-form
                v-container(pa-0='')
                    v-dialog( persistent  v-model='createCategoryDialog'  max-width='500px'   transition="dialog-bottom-transition")
                      create-category( @close="createCategoryDialog=false")
                    productStepper(:hideButtons = 'false' :magnitude="content.magnitude" v-if='!content.type || content.type==="product"' :model ='content', :field='field'  :onSave='updateItem' :context ='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
                    bundleStepper(:hideButtons = 'false' v-if='content.type ==="bundle"' :model ='content', :field='field'  :onSave='updateItem' :context ='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
                    serviceStepper(:hideButtons = 'false' v-if='content.type ==="service"' :model ='content', :field='field'  :onSave='updateItem' :context ='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
                    ingredientStepper(:hideButtons = 'false' v-if='content.type ==="ingredient"' :model ='content', :field='field'  :onSave='updateItem' :context ='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")

</template>
<script>
  import bundleStepper from '../../components/custom/steppers/BundleStepper'
  import productStepper from '../../components/custom/steppers/ProductStepper'
  import serviceStepper from '../../components/custom/steppers/ServiceStepper'
  import ingredientStepper from '../../components/custom/steppers/IngredientStepper'
  import CreateCategory from './CreateCategory'
  const diff = require('deep-object-diff').detailedDiff
  export default {
    components: {
      bundleStepper: bundleStepper,
      productStepper: productStepper,
      serviceStepper: serviceStepper,
      CreateCategory: CreateCategory,
      ingredientStepper: ingredientStepper,
    },
    props: {
      model: {
        type: Object,
        required: true,
        default: () => {},
      },
    },

    data: () => ({
      tempLocations: [],
      currentContext: 'properties',
      createCategoryDialog: false,
      oldVal: {},
      content: {},
      logMessage: 'El producto se ha actualizado',
      logMessage2: [],
      locationId: '',
    }),
    computed: {
      currentTitle () {
        switch (this.content.type) {
          case 'product': return 'Actualizar producto'
          case 'service': return 'Actualizar servicio'
          case 'ingredient': return 'Actualizar ingrediente'
          default: return 'Actualizar producto'
        }
      },
      field () {
        return {
          locations: this.arrayLocations,
          categories: this.$store.getters['categories/getItems'],
        }
      },
      arrayLocations () {
        const vm = this
        const locations = vm.$store.getters['shops/getItems']
        const results = []
        locations.forEach(function (el) {
          results.push({
            id: el.id,
            image: (el.pictures !== undefined ? el.pictures.imageInput1 : '') || '',
            name: el.name,
            price: el.price || vm.model.price.sale,
            stock: el.stock || 0,
          })
        })
        return results
      },
      user () {
        return this.$store.state.users.user
      },
    },
    created () {
      const vm = this
      vm.content = JSON.parse(JSON.stringify(vm.model))
      vm.oldVal = JSON.parse(JSON.stringify(vm.model))
    },
    methods: {
      translate (name) {
        switch (name) {
          case 'product':
            return 'producto'
          case 'service':
            return 'servicio'
          case 'bundle':
            return 'Combo'
          case 'ingredient':
            return 'ingrediente'
        }
      },
      async updateItem () {
        // A post entry.
        const vm = this
        const itemData = vm.content
        // this.$store.commit('setLoading', true);
        const filteredLocation = {}
        if (!Array.isArray(itemData.categories)) {
          itemData.categories = [{
            ...itemData.categories,
          }]
        }
        if (itemData.type === 'product') {
          await itemData.tempLocations.forEach(function (el) {
            if (!el || !el.id) return
            filteredLocation[el.id] = {
              id: el.id,
              image: el.image || '',
              name: el.name,
              magnitude: el.magnitude || 0,
              unit: el.unit || '',
              price: el.price,
              pricewithouttax: el.pricewithouttax ? el.pricewithouttax : el.price,
              purchased: el.purchased || 0,
              sold: el.sold || 0,
              stock: el.stock,
              taxes: el.taxes ? el.taxes : '',
              kitchenAprobal: el.kitchenAprobal || false,
            }
          })
        } else if (itemData.type !== 'ingredient') {
          await itemData.tempLocations.forEach(function (el) {
            if (!el || !el.id) return
            // console.log(el, 'el purchased')
            filteredLocation[el.id] = {
              id: el.id,
              image: el.image || '',
              name: el.name,
              price: el.price,
              stock: el.stock,
              taxes: el.taxes ? el.taxes : '',
              pricewithouttax: el.pricewithouttax ? el.pricewithouttax : el.price,
            }
          })
        } else {
          await itemData.tempLocations.forEach(function (el) {
            // console.log(el, 'el purchased')
            if (!el || !el.id) return
            filteredLocation[el.id] = {
              id: el.id,
              image: el.image || '',
              name: el.name,
              price: el.price,
              stock: el.stock,
            }
          })
        }
        itemData.location = filteredLocation
        itemData.tempLocations = null
        vm.$forceUpdate()
        // tempLocations
        vm.deepEqual(vm.oldVal, itemData)
        setTimeout(function () {
          this.$store.dispatch('products/updateItem', { payload: itemData, message: vm.logMessage2 }).then(() => {
            vm.onSuccess()
          })
        }.bind(this), 1000)
      },
      onSuccess () {
        // this.$router.push({name: 'PropertyList'});
        const vm = this
        vm.$emit('close')
      },
      cancel () {
        this.$emit('close')
      },
      translateKeys (key) {
        let title = ''
        switch (key) {
          case 'sale':
            title = 'precio de venta'
            break
          case 'buy':
            title = 'precio de compra'
            break
          case 'description':
            title = 'descripcion'
            break
          case 'price':
            title = 'el precio de venta'
            break
          case 'stock':
            title = 'el inventario de '
            break
          case 'name':
            title = 'nombre'
            break
          case 'salewithouttax':
          case 'pricewithouttax':
            title = 'precio de venta sin impuestos'
            break
          case 'lowStockAlert':
            title = 'alerta de stock'
            break
          default:
            title = key
            break
        }
        return title
      },
      deepEqual (oldVal, newVal) {
        const vm = this
        const diffs = diff(oldVal, newVal)
        const diffObject = { ...diffs.updated }
        const keysDiff = Object.keys(diffObject)
        for (const key of keysDiff) {
          if (typeof diffObject[key] === 'object') {
            vm.traverse(diffObject[key], key, key)
          } else if (key !== 'taxesChanged') {
            vm.logMessage2.push(`Se cambio ${vm.translateKeys(key)} de ${oldVal[key]} a ${diffObject[key]}`)
          }
        }
      },
      traverse (diffVal, key = '', padreIndex) {
        const vm = this
        for (const index in diffVal) {
          if (!!diffVal[index] && typeof (diffVal[index]) === 'object') {
            vm.traverse(diffVal[index], key, index)
          } else {
            if (index === 'imageInput1') {
              vm.logMessage2.push('Se cambio la imagen del producto')
            } else if (key === 'location') {
              const storeName = vm.arrayLocations.find(element => element.id === padreIndex)
              if (index === 'stock') vm.addChangeInventory(padreIndex)
              if (storeName) vm.logMessage2.push(`Se cambio ${vm.translateKeys(index)} ${storeName.name} a ${diffVal[index]} `)
            } else {
              vm.logMessage2.push(`Se cambio ${vm.translateKeys(index)} a ${diffVal[index]}`)
            }
          }
        }
      },
      addChangeInventory (idStore) {
        const vm = this
        const transaction = {
          type: 'change_inventory',
          items: [
            {
              id: vm.content.id,
              amount: vm.content.location[idStore].stock,
              magnitude: vm.content.location[idStore].magnitude,
              price: parseFloat(vm.content.price.buy).toFixed(2),
              name: vm.content.name,
              qty: +vm.oldVal.location[idStore].stock,
            },
          ],
          time: vm.$moment().format(),
          total: 0,
          location_to: {
            id: vm.content.location[idStore].id,
            image: vm.content.location[idStore].image,
            name: vm.content.location[idStore].name,
          },
          status: 'completed',
          user: {
            name: vm.$store.state.users.profile.name || '',
            email: vm.user.email,
          },
        }
        transaction.total = vm.getCartTotal(transaction.items)
        vm.$store.dispatch('transactions/sendBill', transaction)
      },
      getCartTotal (list) {
        let total = 0
        list.forEach(function (item) {
          total = total + parseFloat((+item.amount - +item.qty) * item.price)
        })
        return total.toFixed(2)
      },
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .ql-video {
        max-width: 100%;

    }
    img{
        max-width: 100%;
        height:auto;
    }
</style>
